import React from 'react'

import withMultiparking from 'hocs/withMultiparking'

import Multiparking from './Screen'

const MultiparkingHOC = Component => {
  const Wrapper = props => <Component {...props} />

  return Wrapper
}

export default withMultiparking(MultiparkingHOC(Multiparking))
